import { useQuery } from "@tanstack/react-query";
import { referenceApi } from "@/lib/api/endpoints";
import type { ReferencePlan } from "@/lib/api/types";
import { qk } from "@/lib/query-keys";

const HOUR = 60 * 60_000;

export function usePlans() {
  const query = useQuery({
    queryKey: qk.plans,
    queryFn: referenceApi.plans,
    staleTime: HOUR,
  });

  const plans: ReferencePlan[] = query.data?.items ?? [];
  return {
    ...query,
    plans,
    /** `null` means Stripe isn't configured — render nothing, not a live badge. */
    testMode: query.data?.testMode ?? null,
    annualMonthsFree: query.data?.annualMonthsFree ?? 0,
  };
}

export function useSectors() {
  const query = useQuery({
    queryKey: qk.sectors,
    queryFn: referenceApi.sectors,
    staleTime: 12 * HOUR,
  });
  return { ...query, sectors: query.data?.items ?? [] };
}

export function useTodoCategories() {
  const query = useQuery({
    queryKey: qk.todoCategories,
    queryFn: referenceApi.todoCategories,
    staleTime: 12 * HOUR,
  });
  return { ...query, categories: query.data?.items ?? [] };
}

export function useBadgeCatalogue() {
  const query = useQuery({
    queryKey: qk.badgeCatalogue,
    queryFn: referenceApi.badges,
    staleTime: 12 * HOUR,
  });
  return { ...query, badges: query.data?.items ?? [] };
}
